import { render, staticRenderFns } from "./IbChartsPlaceholder.vue?vue&type=template&id=5fa24f3b"
import script from "./IbChartsPlaceholder.vue?vue&type=script&lang=js"
export * from "./IbChartsPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports